import { useEffect, useState } from "react";
import moment from "moment";
import { twMerge } from "tailwind-merge";
import { ScrollArea } from "components/ui/scroll-area";
import { usePostInvoiceDetail } from "hooks/console/map/usePostMapInvoiceDetail";
import { usePopupStore } from "store/usePopupStore";
import { deliveryStatusList } from "./deliveryStatus";
import ic_order_status1 from "assets/morning/icon/statusReception.svg";
import ic_order_status2 from "assets/morning/icon/statusPickUpReservation.svg";
import ic_order_status3 from "assets/morning/icon/statusPickupComplete.svg";
import ic_order_status4 from "assets/morning/icon/statusInDelivery.svg";
import ic_order_status5 from "assets/morning/icon/statusDeliveryCompleted.svg";
import arrow_down from "assets/morning/icon/upArrow.svg";
import ic_tit1 from "assets/morning/icon/shipping.svg";
import ic_tit2 from "assets/morning/icon/shipping2.svg";

interface resultData {
    i_kind_label: string;
    i_pickup_name: string;
    i_phone: string;
    label: string;
}

interface InfoData {
    s_bl_no: string;
    o_date: string;
    w_date: string;
    o_kind: string;
    s_kind: string;
    payKind: string;
    yogum: string;
    yogumtel: string;
    memo: string | null;
    //출발지 정보
    f_company: string;
    f_ccode: string;
    f_name: string | null;
    f_mobile: string;
    f_post: string;
    f_address: string;
    f_address_detail: string;
    //도착지 정보
    t_company: string;
    t_name: string | null;
    t_mobile: string;
    t_post: string;
    t_address: string;
    t_address_detail: string;
    //배송상세 내역
    detailResult: resultData[];
}

interface SearchItemDetailProps {
    index: string;
    handleClose: () => void;
}

const statusIcons: Record<number, string> = {
    1: ic_order_status1,
    2: ic_order_status2,
    3: ic_order_status3,
    4: ic_order_status4,
    5: ic_order_status5,
};

const statusLiStyle =
    "flex flex-col gap-[6px] pl-[32px] relative before:absolute before:content-[''] before:w-[12px] before:h-[12px] before:left-[6px] before:top-[6px] before:rounded-full before:bg-white before:border-2 before:border-[#0054D1] after:absolute after:content-[''] after:w-[1px] after:h-[calc(100%-24px)] after:left-[11px] after:bottom-0 after:border-l after:border-dashed after:border-[#002966]";
const statusLastLiStyle = twMerge(statusLiStyle, "after:hidden");
const boxStyle = "bg-white rounded-[16px] p-[20px_16px]";
const titStyle =
    "flex items-center gap-[12px] pb-[16px] border-b border-[#E1E2E4] mb-[16px] [&>p]:text-[20px] [&>p]:text-[#132E47] [&>p]:font-[700]";
const thStyle = "p-[8px_0] text-[#878A93] font-[500] text-left align-top";
const tdStyle = "p-[8px_12px] text-[#132E47] [&>span]:text-[14px] [&>span]:font-[500] [&>span]:text-[#FF7B2E]";

export default function SearchItemDetail({ index, handleClose }: SearchItemDetailProps) {
    const { setConfirmPop, setLoadingPop } = usePopupStore();
    const [info, setInfo] = useState<InfoData | null>(null);
    const [statusNum, setStatusNum] = useState<number | null>(null);
    const [statusOn, setStatusOn] = useState(false);
    const { mutate: postInvoiceDetail } = usePostInvoiceDetail(() => {});

    //운송장 상세정보 가져오는 함수
    const getInfo = async () => {
        postInvoiceDetail(
            {
                s_bl_kind: "E", //고정값
                s_bl_no: index,
                s_bl_seq: "001", //고정값
            },
            {
                onSuccess: data => {
                    console.log(data);
                    setInfo(data.data[0]);
                },
            },
        );
        // try {
        //     const res = await commonService.invoiceDetail(index);
        //     if (res.statusCode === 200) {
        //         const data = res.data[0];
        //         setInfo(data);
        //     }
        // } catch (error) {
        //     console.error("Failed to fetch list:", error);
        // }
    };

    //운송장 상세정보 가져오기
    useEffect(() => {
        getInfo();
    }, [index]);

    //날짜변환 함수
    const formatDate = (inputDate: string): string => {
        const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];

        // 요일 제거
        const cleanedDate = inputDate.replace(/(월요일|화요일|수요일|목요일|금요일|토요일|일요일)/g, "").trim();

        const date = moment(cleanedDate, "YYYY.MM.DD HH:mm:ss");

        if (!date.isValid()) {
            return "";
        }

        const formattedDate = `${date.format("MM월 DD일")} (${daysOfWeek[date.day()]}) ${date.format("HH:mm:ss")}`;
        return formattedDate;
    };

    //현재 운송장상태값 체크
    useEffect(() => {
        if (info?.o_kind) {
            const updatedStatusNum = deliveryStatusList.find(item => item.name === info.o_kind)?.num || null;
            setStatusNum(updatedStatusNum);
        }
    }, [info]);

    //운송장번호 복사하기
    const handleCopyText = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            setConfirmPop(true, "알림", "운송장번호가 복사되었습니다.", 1);
        } catch (error) {
            console.log(`운송장번호 복사실패: ${error}`);
        }
    };

    return (
        <>
            {info && (
                <div className="flex flex-col border-r border-[#E1E2E4] bg-white w-[372px]">
                    <div className="flex items-center justify-center h-[60px] relative">
                        <p className="text-[20px] font-[500]">운송장 내역 현황</p>
                        <button
                            type="button"
                            className="absolute w-[56px] h-full right-0 top-0 text-[0] -indent-[9999px] bg-ic_close bg-no-repeat bg-center"
                            onClick={handleClose}
                        >
                            닫기버튼
                        </button>
                    </div>
                    <ScrollArea className="w-full h-[calc(100%-60px)]">
                        <div className="flex items-center justify-center gap-[8px] py-[14px]">
                            <p className="text-[24px] font-[500]">{info.s_bl_no}</p>
                            <button
                                type="button"
                                className="text-[#878A93] font-[500] pl-[20px] bg-ic_copy bg-left bg-no-repeat"
                                onClick={() => handleCopyText(info.s_bl_no)}
                            >
                                복사
                            </button>
                        </div>
                        <div className="m-[12px_16px_20px] border border-[#DDD] rounded-[12px] bg-[#F7F7F8]">
                            <div className="flex justify-between p-[20px_16px] bg-white rounded-[12px]">
                                <div>
                                    <p className="text-[20px] leading-7">
                                        {formatDate(info.o_date)} <br />
                                        <strong>{info.o_kind}</strong> 되었습니다.
                                    </p>
                                    <p className="text-[#878A93] pt-[4px]">접수일자 {info.w_date}</p>
                                </div>
                                {statusNum !== null && statusNum !== 6 && (
                                    <div>
                                        <div className="w-[56px] h-[56px] rounded-[8px] bg-[#FFF3EC] flex justify-center items-center">
                                            {statusNum !== null && <img src={statusIcons[statusNum]} alt={`상태 ${statusNum}`} />}
                                        </div>
                                        <p className="text-[13px] text-[#FF7B2E] font-[700] text-center pt-[4px]">{info.o_kind}</p>
                                    </div>
                                )}
                            </div>
                            <ul className={`p-[16px] flex flex-col gap-[8px] overflow-hidden ${statusOn ? "h-auto" : "h-[110px]"}`}>
                                {info.detailResult.map((item, i) => {
                                    const last = i === info.detailResult.length - 1;
                                    return (
                                        <li key={`result_${i}`} className={last ? statusLastLiStyle : statusLiStyle}>
                                            <div
                                                className={`w-[85px] rounded-[4px] text-[14px] font-[500] py-[5px] text-center bg-none ${
                                                    i > 0 ? "text-[#0054D1] border border-[#0054D1]" : " bg-[#0054D1] text-white"
                                                }`}
                                            >
                                                {item.i_kind_label}
                                            </div>
                                            <p className="font-[500]">{item.label}</p>
                                            <p className="text-[#666]">
                                                {item.i_pickup_name ? `${item.i_pickup_name} (${item.i_phone})` : "-"}
                                            </p>
                                        </li>
                                    );
                                })}
                            </ul>
                            {info.detailResult.length > 1 && (
                                <button
                                    type="button"
                                    className="w-full h-[56px] flex items-center justify-center gap-[8px] text-[#5A5C63] font-[500]"
                                    onClick={() => setStatusOn(!statusOn)}
                                >
                                    배송상세 {statusOn ? "접기" : "더보기"}
                                    <img src={arrow_down} alt="화살표아이콘" className={statusOn ? "rotate-180" : ""} />
                                </button>
                            )}
                        </div>
                        <div className="bg-[#F3F5F8] p-[20px_16px] flex flex-col gap-[12px]">
                            <div className={boxStyle}>
                                <div className={titStyle}>
                                    <img src={ic_tit1} alt="아이콘" />
                                    <p>발송 및 지불 방법</p>
                                </div>
                                <table>
                                    <colgroup>
                                        <col width={80} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th className={thStyle}>발송구분</th>
                                            <td className={tdStyle}>{info.s_kind}</td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>지불방법</th>
                                            <td className={tdStyle}>{info.payKind}</td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>요금처</th>
                                            <td className={tdStyle}>{`${info.yogum} (${info.yogumtel})`}</td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>메모</th>
                                            <td className={tdStyle}>{info.memo || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className={boxStyle}>
                                <div className={titStyle}>
                                    <img src={ic_tit2} alt="아이콘" />
                                    <p>출발지 정보</p>
                                </div>
                                <table>
                                    <colgroup>
                                        <col width={80} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th className={thStyle}>상호</th>
                                            <td className={tdStyle}>
                                                {info.f_company} <span>{info.f_ccode}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>연락처</th>
                                            <td className={tdStyle}>{info.f_mobile}</td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>담당자</th>
                                            <td className={tdStyle}>{info.f_name ? info.f_name : "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>주소</th>
                                            <td className={tdStyle}>{`[${info.f_post}] ${info.f_address} ${info.f_address_detail}`}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className={boxStyle}>
                                <div className={titStyle}>
                                    <img src={ic_tit2} alt="아이콘" />
                                    <p>도착지 정보</p>
                                </div>
                                <table>
                                    <colgroup>
                                        <col width={80} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th className={thStyle}>상호</th>
                                            <td className={tdStyle}>{info.t_company}</td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>연락처</th>
                                            <td className={tdStyle}>{info.t_mobile}</td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>담당자</th>
                                            <td className={tdStyle}>{info.t_name ? info.t_name : "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className={thStyle}>주소</th>
                                            <td className={tdStyle}>{`[${info.t_post}] ${info.t_address} ${info.t_address_detail}`}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ScrollArea>
                </div>
            )}
        </>
    );
}
